module.exports = new __parcel__URL__("More.e627945d.svg").toString();